import type { Action, StoreActionApi } from 'react-sweet-state';
import type { State, JiraStatus } from '../../../../common/types';

export type SetThirdPartyStatusOptioAction = (newStatus: JiraStatus) => Action<State, void, void>;

export const setThirdPartyStatusOption: SetThirdPartyStatusOptioAction =
	(newStatus: JiraStatus) =>
	({ setState, getState }: StoreActionApi<State>) => {
		const { thirdPartyState } = getState();
		if (thirdPartyState.thirdPartyStatusMapping == null) {
			return;
		}

		const newOptions = thirdPartyState.thirdPartyStatusMapping.availableJiraStatuses
			.concat([newStatus])
			.sort((a, b) => a.name.localeCompare(b.name));

		setState({
			thirdPartyState: {
				...thirdPartyState,
				thirdPartyStatusMapping: {
					...thirdPartyState.thirdPartyStatusMapping,
					availableJiraStatuses: newOptions,
				},
			},
		});
	};
